import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { connect, useDispatch } from 'react-redux'
import SubnavBar from 'Components/Shared/SubnavBar'
import { Modal, Row, Col } from 'antd'
import { RouteComponentProps } from 'react-router-dom'
import RootState from 'typings/RootState'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import { selectedProjectCodeSelector } from 'features/project/project.selector'
import {
  userEmailSelector,
  serviceTokenSelector,
} from 'features/sensitive/sensitive.selector'
import {
  selectData,
  selectEvent,
  selectActionEvent,
  selectSorting,
  selectCanSendStatus,
} from 'features/cmpj/road/audit/selector'
import { sortingDashboard } from 'features/cmpj/road/audit/actions'
import {
  getDashboard,
  getCanSendStatus,
  sendToQC,
} from 'features/cmpj/road/audit/api'
import {
  GetDashboardReq,
  GetCanSendStatusReq,
  SendToQCReq,
  TypeOfTask,
} from 'features/cmpj/road/audit/types'
import { translate } from 'i18n'
import TKeys from 'i18n/translationKey'

import NoCard from 'Components/Shared/NoCard'
import Loading from 'Components/Shared/Loading'
import { ColumnHeader } from 'Components/Shared'
import RoadTab from 'Components/Shared/Tab/RoadTab'
import EventModal from 'Components/Shared/Modal/EventModal'

import Menu from '../../../Menu'
import InProgressCard from './InProgressCard'
import FixFromQcCard from './FixFromQcCard'

const breadcrumbs: BreadcrumbLink[] = [
  {
    url: '/',
    title: 'Home',
    icon: '/home.png',
    active: true,
    showTitle: false,
  },
  {
    url: '/',
    title: translate(TKeys.Breadcrumb.dashboard),
    active: false,
    showTitle: false,
  },
]

type Props = ReduxProps & DispatchProps & RouteComponentProps

const CmAuditRoadDashboard: React.ComponentType<Props> = props => {
  const [enableModal, setEnableModal] = useState(false)
  const [isSendRequest, setIsSendRequest] = useState(false)
  const {
    data,
    event,
    actionEvent,
    sorting,
    canSendStatus,
    token,
    ProjectCode,
    UserEmail,
    sortingTask,
  } = props

  const dispatch = useDispatch()
  useEffect(() => {
    getDashboardData()
    setIsSendRequest(false)
    setEnableModal(false)
  }, [ProjectCode])

  const getDashboardData = () => {
    setEnableModal(true)
    const req: GetDashboardReq = {
      ProjectCode,
      UserEmail,
    }

    dispatch(getDashboard(token, req))

    const reqStatus: GetCanSendStatusReq = {
      ProjectCode,
      UserEmail,
    }
    dispatch(getCanSendStatus(token, reqStatus))
  }

  const onConfirmSend = () => {
    const modalContent = (
      <ModalContent>
        <div>ส่งคำขอหา QC</div>
        <span>
          คุณได้ตรวจสอบความเรียบร้อยแล้วและต้องการส่งคำขอยืนยันส่งคำขอหา QC
          ใช่หรือไม่ ?
        </span>
      </ModalContent>
    )

    Modal.confirm({
      onOk: onSendRequest,
      width: '388px',
      onCancel() {},
      content: modalContent,
      okText: 'ยืนยัน',
      okButtonProps: {
        className: 'btn-rectangle ok-btn',
      },
      cancelText: 'ยกเลิก',
      cancelButtonProps: {
        className: 'btn-rectangle cancle-btn',
      },
      centered: true,
      icon: null,
      className: 'login-modal-window',
    })
  }

  const onSendRequest = () => {
    setIsSendRequest(true)
    setEnableModal(true)
    const req: SendToQCReq = {
      ProjectCode,
      UserEmail,
    }

    dispatch(sendToQC(token, req))
  }

  const closeEnableModal = () => {
    setEnableModal(false)
  }

  const onCompleted = () => {
    console.log('on complete')
    closeEnableModal()
    if (isSendRequest) {
      setIsSendRequest(false)
      getDashboardData()
    }
  }

  const loading = (
    <div style={{ textAlign: 'center' }}>
      <Loading />
    </div>
  )

  const renderCard = (task: any[], type: string) => {
    let card = [] as any

    if (type === TypeOfTask.InProgress) {
      card = task.map((activity, index) => (
        <InProgressCard key={index} task={activity} />
      ))
    }

    if (type === TypeOfTask.FixFromQC) {
      card = task.map((activity, index) => (
        <FixFromQcCard key={index} task={activity} />
      ))
    }

    return card
  }

  const renderTaskLen = (
    task: any[],
    header: string,
    orderName: string,
    type: string
  ) => {
    const card =
      task && task.length > 0 ? (
        renderCard(task, type)
      ) : (
        <NoCard text="ไม่มีรายการ" />
      )
    const content = event.IsLoading ? loading : card
    const title = `${header}`
    return (
      <Col span={8}>
        <FullColumn>
          <ColumnHeader
            heading={title}
            orderName={orderName}
            type={sorting[type]}
            onSort={() => {
              sortingTask(type)
            }}
          />
          {content}
        </FullColumn>
      </Col>
    )
  }

  return (
    <>
      <EventModal
        event={[event, actionEvent]}
        enable={enableModal}
        successCalback={onCompleted}
        errorCalback={closeEnableModal}
      />
      <Menu selected="road" />
      <SubnavBar breadcrumbs={breadcrumbs} hideSearch={true} />
      <RoadTab
        selected="AuditRoad"
        onClick={canSendStatus ? onConfirmSend : undefined}
        visible={true}
      />
      <Space />
      <MainPage>
        <Row type="flex">
          {renderTaskLen(
            data.InProgress,
            'QC กำลังดำเนินการ',
            '',
            TypeOfTask.InProgress
          )}
          {renderTaskLen(data.FixFromQC, 'ผลการตรวจ', '', TypeOfTask.FixFromQC)}
        </Row>
      </MainPage>
    </>
  )
}

const MainPage = styled.div`
  padding: 0 120px;
  background-color: #f5f6fa;
  width: 100vw;
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  overflow-x: scroll;
`

const FullColumn = styled.div`
  padding-right: 20px;
`

const Space = styled.div`
  margin: 20px 0;
`

const ModalContent = styled.div`
  text-align: center;
  border-radius: 10px;
  div {
    font-size: 24px;
    font-family: 'DB Helvethaica X 75 Bd';
    margin-bottom: 18px;
  }

  span {
    font-size: 20px;
    font-family: 'DB Helvethaica X 55 Regular';
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    data: selectData(state),
    event: selectEvent(state),
    actionEvent: selectActionEvent(state),
    sorting: selectSorting(state),
    canSendStatus: selectCanSendStatus(state),
    token: serviceTokenSelector(state),
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {
  sortingTask: sortingDashboard,
}

type DispatchProps = typeof mapDispatchToProps

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CmAuditRoadDashboard)
